import { useMemo } from "react"
import { useStore } from "./orbitStore"

const usePairedSegments = segments => {
  const pairs = useMemo(
    () =>
      segments.map((_, i) => ({
        fw: segments[i][0],
        rv: segments[prevIndex(i, segments)][1]
      })),
    [segments]
  )
  const videos = useMemo(() => segments.flat(), [segments])

  const index = useStore(state => state.index)
  const setIndex = useStore(state => state.setIndex)

  const direction = useStore(state => state.direction)
  const setDirection = useStore(state => state.setDirection)

  const playing = useStore(state => state.playing)
  const setPlaying = useStore(state => state.setPlaying)

  // console.log("playing", playing)
  // console.log("index", index)
  // console.log("direction", direction)

  const pair = pairs[index]
  const current = direction === -1 ? pair.rv : pair.fw

  return {
    videos,
    current,
    playing,
    left: pair.rv,
    right: pair.fw,
    onPlay: video => {
      setDirection(video === pair.rv ? -1 : 1)
      setPlaying(video)
      // setTimeout(() => {
      // }, 50)
    },
    onEnd: () => {
      setPlaying()
      setIndex(direction === -1 ? prevIndex(index, pairs) : nextIndex(index, pairs))
    }
  }
}

const prevIndex = (current, arr) => {
  return current === 0 ? arr.length - 1 : current - 1
}

const nextIndex = (current, arr) => {
  return (current + 1) % arr.length
}

export default usePairedSegments
